import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, output, viewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { fromEvent, startWith, skip, tap, debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-search-engine',
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule
  ],
  templateUrl: './search-engine.component.html',
  styleUrls: ['./search-engine.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchEngineComponent {
  private _searchInputRef = viewChild<ElementRef>('inputSearch');
  public searchTermChange = output<string>();
  
  private _cdr = inject(ChangeDetectorRef);
  
  public value = '';
  
  public isDebouncing = false;
  
   ngAfterViewInit() {
    if (this._searchInputRef()) {
      const searchInputEl = this._searchInputRef()!.nativeElement;
      fromEvent(searchInputEl, 'input')
        .pipe(
          startWith(''), // Emit an initial value to avoid the debounce
          skip(2), // Skip the first two events to avoid the initial value
          tap(() => {
            this.isDebouncing = true;
            this._cdr.detectChanges();
          }),
          debounceTime(300),
          distinctUntilChanged()
        )
        .subscribe((event: unknown) => {
          if (event instanceof Event) {
            const searchTerm = (event.target as HTMLInputElement).value;
            this.searchTermChange.emit(searchTerm);
            this.value = searchTerm;
            this.isDebouncing = false;
            this._cdr.detectChanges();
          }
        });
    }
  }

  handleClearInput(): void {
    this.value = '';
    this.searchTermChange.emit('');
  }
}
